export const IMPORT_SOURCES = {
  letterboxd: {
    key: "letterboxd",
    label: "Letterboxd",
    listLabel: "lists",
    contentType: ["movie"],

    upload: {
      accept: ".zip",
      buttonText: "Upload .zip file",
    },

    instructions: [
      {
        type: "link",
        text: "Visit letterboxd.com/settings/data/",
        href: "https://letterboxd.com/settings/data/",
      },
      {
        type: "text",
        text: "Click the export your data button — this will download a .zip file",
      },
      {
        type: "text",
        text: "Once downloaded, upload the .zip file below",
      },
      {
        type: "text",
        text: "The import will start automatically",
      },
    ],

    steps: [
      {
        value: "queued",
        label: "Queued",
        description:
          "The servers are busy processing other imports at the moment, yours will start soon",
      },
      {
        value: "extracting",
        label: "Extracting Letterboxd data",
      },
      {
        value: "processing_finished",
        label: "Processing finished movies",
        progress: true,
      },
      {
        value: "processing_queued",
        label: "Processing queued movies",
        progress: true,
      },
      {
        value: "processing_collections",
        label: "Processing collections",
        progress: true,
      },
    ],

    postImportNotes: [
      "Watched items are added to your track page as finished. Entries include ratings, reviews, and watch dates, and are set to private by default. You can update their visibility anytime.",
      "Watchlist items are added to your track page as queued.",
      "Your lists (we call them collections) can be found on the curate page.",
      "If something looks off (like an entry tagged to the wrong movie), just flag it on the track page and we’ll fix it for you.",
      "The import process doesn't currently support TV shows. If you logged any on Letterboxd and they've been imported incorrectly as movies, just flag them on the track page and we'll sort it.",
    ],
  },

  goodreads: {
    key: "goodreads",
    label: "Goodreads",
    listLabel: "shelves",
    contentType: ["book"],

    upload: {
      accept: ".csv",
      buttonText: "Upload .csv file",
    },

    instructions: [
      {
        type: "link",
        text: "Visit goodreads.com/review/import",
        href: "https://www.goodreads.com/review/import",
      },
      {
        type: "text",
        text: "Click the export library button to download a CSV file",
      },
      {
        type: "text",
        text: "Once downloaded, upload the CSV file below",
      },
      {
        type: "text",
        text: "The import will start automatically",
      },
    ],

    steps: [
      {
        value: "queued",
        label: "Queued",
        description:
          "The servers are busy processing other imports at the moment, yours will start soon",
      },
      {
        value: "extracting",
        label: "Extracting Goodreads data",
      },
      {
        value: "processing_books",
        label: "Processing books",
        progress: true,
      },
      {
        value: "processing_shelves",
        label: "Processing shelves",
        progress: true,
      },
    ],

    postImportNotes: [
      "Books marked as 'read' are added to your track page as finished. Ratings, reviews, and read dates are imported as private journal entries (you can change visibility anytime).",
      "'Want to read' books are added as queued, and 'currently reading' books as started.",
      "Your shelves (we call them collections) can be found on the curate page.",
      "If something looks off (like a journal entry tagged to the wrong book), just flag it on the track page and we’ll fix it for you.",
    ],
  },

  trakt: {
    key: "trakt",
    label: "Trakt",
    contentType: ["tvshow", "movie"],
    listLabel: "lists",

    upload: {
      accept: ".zip",
      buttonText: "Upload .zip file",
    },

    instructions: [
      {
        type: "link",
        text: "Visit app.trakt.tv/settings/data",
        href: "https://app.trakt.tv/settings/data",
      },
      {
        type: "text",
        text: "Scroll down to 'Export' and click 'Export now' to download a .zip file of your Trakt data",
      },
      {
        type: "text",
        text: "Once downloaded, upload the .zip file below",
      },
      {
        type: "text",
        text: "The import will start automatically",
      },
    ],

    steps: [
      {
        value: "queued",
        label: "Queued",
        description:
          "The servers are busy processing other imports at the moment, yours will start soon",
      },
      {
        value: "extracting",
        label: "Extracting Trakt data",
        progress: true,
      },
      {
        value: "processing_tvshows",
        label: "Processing TV shows",
        progress: true,
      },
      {
        value: "processing_movies",
        label: "Processing movies",
        progress: true,
      },
      {
        value: "processing_watchlist",
        label: "Processing watchlist",
        progress: true,
      },
      {
        value: "processing_collections",
        label: "Processing collections",
        progress: true,
      },
    ],

    postImportNotes: [
      "TV shows and movies from your Trakt watch history are added to your track page as finished. Ratings, reviews, and watch dates are imported as private journal entries (you can change visibility anytime).",
      "Watchlist items are added as queued. TV seasons you were part way through are added as started.",
      "Your Trakt lists, favourites and library are added as collections to the curate page.",
      "If something looks off (like a journal entry tagged to the wrong TV show), just flag it and we’ll fix it for you.",
    ],
  },

  storygraph: {
    key: "storygraph",
    label: "StoryGraph",
    listLabel: "tags",
    contentType: ["book"],

    upload: {
      accept: ".csv",
      buttonText: "Upload .csv file",
    },

    instructions: [
      {
        type: "link",
        text: "Visit thestorygraph.com",
        href: "https://thestorygraph.com/",
      },
      {
        type: "text",
        text: "Sign in and open the menu in the top right",
      },
      {
        type: "text",
        text: "Click 'Manage Account' and scroll down to 'Manage Your Data'",
      },
      {
        type: "text",
        text: "Click 'Export StoryGraph Library' — a CSV file will be emailed to your StoryGraph account email",
      },
      {
        type: "text",
        text: "Once you receive the email and download the file, upload it below",
      },
      {
        type: "text",
        text: "The import will start automatically",
      },
    ],

    steps: [
      {
        value: "queued",
        label: "Queued",
        description:
          "The servers are busy processing other imports at the moment, yours will start soon",
      },
      {
        value: "extracting",
        label: "Extracting Storygraph data",
      },
      {
        value: "processing_books",
        label: "Processing books",
        progress: true,
      },
      {
        value: "processing_collections",
        label: "Processing collections",
        progress: true,
      },
    ],

    options: [
      {
        key: "rating_rounding",
        label: "Round quarter-star ratings",
        choices: [
          { value: "up", label: "Up (e.g. 3.25 → 3.5)" },
          { value: "down", label: "Down (e.g. 3.25 → 3.0)" },
        ],
        default: "up",
      },
      {
        key: "note_visibility",
        label: "Who can see your imported reviews?",
        choices: [
          { value: "everyone", label: "Everyone" },
          { value: "followers", label: "Followers" },
          { value: "only_me", label: "Only me" },
        ],
        default: "everyone",
      },
    ],

    postImportNotes: [
      "Books you've read are added to your track page as finished. Ratings, reviews, and read dates are imported as journal entries.",
      "'Currently reading' books are added as started, 'to-read' as queued, and 'did not finish' as stopped.",
      "Your tags (we call these collections) can be found on the curate page.",
      "If something looks off (like a journal entry tagged to the wrong book), just flag it on the track page and we'll fix it for you.",
    ],
  },

  tvtime: {
    key: "tvtime",
    label: "TV Time",
    listLabel: "lists",
    contentType: ["tvshow", "movie"],

    upload: {
      accept: ".zip",
      buttonText: "Upload .zip file",
    },

    instructions: [
      {
        type: "link",
        text: "Visit https://gdpr.tvtime.com/gdpr/self-service",
        href: "https://gdpr.tvtime.com/gdpr/self-service",
      },
      {
        type: "text",
        text: "Please note TV Time is shutting down as of 15th July 2026 — you must have exported your data before this date",
      },
      {
        type: "text",
        text: "Click the download button — this will download a .zip file",
      },
      {
        type: "text",
        text: "Once downloaded, upload the .zip file below",
      },
      {
        type: "text",
        text: "The import will start automatically",
      },
    ],

    steps: [
      {
        value: "queued",
        label: "Queued",
        description:
          "The servers are busy processing other imports at the moment, yours will start soon",
      },
      {
        value: "extracting",
        label: "Extracting TV Time data",
      },
      {
        value: "processing_movies",
        label: "Processing movies",
        progress: true,
      },
      {
        value: "processing_tvshows",
        label: "Processing TV shows",
        progress: true,
      },
      {
        value: "processing_collections",
        label: "Processing collections",
        progress: true,
      },
    ],

    options: [
      {
        key: "note_visibility",
        label: "Who can see your imported comments?",
        choices: [
          { value: "everyone", label: "Everyone" },
          { value: "followers", label: "Followers" },
          { value: "only_me", label: "Only me" },
        ],
        default: "everyone",
      },
    ],

    postImportNotes: [
      "Your watch history can be found on the track page under 'Finished' and 'Started'. Your watchlist can be found under 'Queued'.",
      "Curate tracks TV shows at the season level, so if you watched a few episodes of a season, that season will be marked as started. If you finished all episodes of a season, it will be marked as finished.",
      "Season-level ratings are calculated as an average of the ratings you gave to individual episodes.",
      "Comments you left on movies, shows, and episodes are imported as journal notes — episode comments are grouped onto their season's note, since Curate tracks TV at the season level.",
      "Lists are imported as collections and can be found on the curate page. TV time only provides the details of movies that you have watched or added to your watchlist, so please note that any movies that appear in a list but that you never otherwise tracked unfortunately can't come across.",
      "If something looks off (like a journal entry tagged to the wrong movie/show), just flag it on the track page and we'll fix it for you.",
    ],
  },

  imdb: {
    key: "imdb",
    label: "IMDb",
    contentType: ["movie", "tvshow"],
    beta: true,

    upload: {
      accept: ".csv",
      multiple: true,
      buttonText: "Choose .csv files",
      submitText: "Start import",
      fileTypes: [
        {
          key: "ratings",
          label: "Ratings",
          requiredHeaders: ["Const", "Your Rating", "Date Rated"],
          excludeHeaders: ["Position"],
        },
        {
          key: "watchlist",
          label: "Watchlist",
          requiredHeaders: ["Position", "Const", "Created"],
        },
      ],
    },

    instructions: [
      {
        type: "link",
        text: "Visit imdb.com (use the website, not the mobile app)",
        href: "https://www.imdb.com",
      },
      {
        type: "text",
        text: 'To export your ratings, go to "Your Ratings" from the user menu in the top right then click the three dots (labelled actions) in the top right and select export',
      },
      {
        type: "text",
        text: 'To export your watchlist, go to "Your Watchlist" from the user menu in the top right then click the three dots (labelled actions) in the top right and select export',
      },
      {
        type: "text",
        text: "Once you've downloaded the files, upload either or both of them below",
      },
      {
        type: "text",
        text: "Configure the import using the options below and then tap start import",
      },
    ],

    steps: [
      {
        value: "queued",
        label: "Queued",
        description:
          "The servers are busy processing other imports at the moment, yours will start soon",
      },
      {
        value: "extracting",
        label: "Extracting IMDb data",
        progress: true,
      },
      {
        value: "processing_movies",
        label: "Processing movies",
        progress: true,
      },
      {
        value: "processing_tvshows",
        label: "Processing TV shows",
        progress: true,
      },
    ],

    options: [
      {
        key: "rating_dates_are_watch_dates",
        label:
          "Are your IMDb rating dates a reasonable proxy for when you watched things?",
        choices: [
          {
            value: "yes",
            label: "Yes, use rating dates as watch dates",
            caption:
              "Recommended if you rated things approximately when you watched them, otherwise entries come in as undated and won't show up when you filter your stats by year. You can edit your watch dates at any time.",
          },
          { value: "no", label: "No, import as undated" },
        ],
        default: "yes",
      },
    ],

    postImportNotes: [
      "Movies and TV series you've rated are added to your track page as finished.",
      "TV seasons are only set to finished if all episodes are rated (season rating = average of episode ratings), otherwise the season is added to the track page as started.",
      "Watchlist items are added to your track page as queued if they have no rating. Rated items in your watchlist are added as finished.",
      "If you have TV episodes in your watchlist, the season it belongs to will be queued (Curate tracks seasons not episodes).",
      "IMDb doesn't currently allow exporting of reviews. If you wish to bring these over, you'll need to copy these manually and paste them as notes within new or existing journal entries.",
      "If something looks off (like a journal entry tagged to the wrong movie/show), just flag it and we'll fix it for you.",
    ],
  },
};
